import { Quote } from "lucide-react";
import { Stars } from "@/components/Stars";

/** Approved customer review, quote-style card. */
export function ReviewCard({ review, compact = false }) {
  const meta = [review.role, review.company].filter(Boolean).join(" · ");
  return (
    <figure
      data-testid={`review-card-${review.id}`}
      className="group relative flex h-full flex-col rounded-2xl border border-line bg-white p-7 shadow-sm transition-[border-color,box-shadow] hover:border-royal/40 hover:shadow-md"
    >
      <Quote
        className="absolute right-6 top-6 h-8 w-8 text-royal-light transition-colors group-hover:text-royal/30"
        aria-hidden="true"
      />
      <Stars rating={review.rating} />
      <blockquote
        className={`mt-4 flex-1 leading-relaxed text-ink ${compact ? "text-sm line-clamp-5" : "text-base"}`}
      >
        “{review.text}”
      </blockquote>
      <figcaption className="mt-6 flex items-center gap-3 border-t border-line pt-5">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-steel font-poster text-sm font-bold text-white">
          {review.name.trim().charAt(0).toUpperCase()}
        </span>
        <div className="min-w-0">
          <p className="truncate font-poster text-sm font-bold text-steel">{review.name}</p>
          {meta && <p className="truncate font-mono-sub text-[11px] text-mute">{meta}</p>}
        </div>
        {review.service && (
          <span className="ml-auto hidden shrink-0 rounded border border-line bg-cloud px-2 py-1 font-mono-sub text-[10px] text-steel sm:inline-block">
            {review.service}
          </span>
        )}
      </figcaption>
    </figure>
  );
}
